import { Card, CardContent } from "@/components/ui/card";
import { Building2, Stethoscope, ArrowUpRight, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";

const Services = () => {
  const hospitalServices = [
    { name: "Lentes de Contato - porcelanas ultrafinas personalizadas", slug: "lentes-de-contato-dental" },
    { name: "Clareamento Dental - sorriso mais branco com segurança", slug: "clareamento-dental" },
    { name: "Restaurações em Resina - naturais e imperceptíveis", slug: "restauracoes-esteticas" }
  ];

  const ambulatoryServices = [
    { name: "Harmonização Facial - preenchimentos naturais", slug: "harmonizacao-orofacial" },
    { name: "Bioestimulador de Colágeno - rejuvenescimento progressivo", slug: "bioestimulador-de-colageno" },
    { name: "Cirurgia Plástica Gengival - correção de sorriso gengival", slug: "cirurgia-plastica-gengival" },
    { name: "Enxertos Gengivais - proteção e estética", slug: "enxerto-gengival" },
    { name: "Tratamento Periodontal - saúde da gengiva", slug: "tratamento-periodontal" }
  ];

  return (
    <section className="py-6 sm:py-8 lg:py-12 bg-background relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-background via-secondary/30 to-background" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-gradient-gold opacity-5 blur-[120px] rounded-full" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16 animate-fade-in-up">
          <p className="text-accent font-inter text-sm uppercase tracking-wider mb-3 inline-block px-4 py-2 rounded-full border border-accent/30 bg-accent/5">
            Especialidade
          </p>
          <h2 className="font-kiona text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mt-4 mb-4">
            Dentística Estética e<br />
            <span className="text-accent">Harmonização Facial</span>
          </h2>
          <p className="text-muted-foreground font-inter text-lg max-w-3xl mx-auto leading-relaxed">
            Cuidamos da sua saúde bucal, estética do sorriso e harmonia facial de forma integrada. 
            Cada tratamento é planejado com atenção às suas características únicas, utilizando técnicas 
            modernas e minimamente invasivas para resultados naturais que realçam sua beleza.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {/* Estética Dental */}
          <Card className="bg-card border-border hover:border-primary/30 transition-all duration-300 animate-fade-in-up">
            <CardContent className="p-8">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-14 h-14 rounded-full bg-gradient-gold flex items-center justify-center flex-shrink-0 shadow-gold">
                  <Building2 className="w-7 h-7 text-primary-foreground" />
                </div>
                <div>
                  <h3 className="font-kiona text-2xl font-semibold text-foreground mb-2">
                    Estética Dental
                  </h3>
                  <p className="text-sm text-primary font-inter">Sorrisos naturais e saudáveis</p>
                </div>
              </div>
              
              <ul className="space-y-3">
                {hospitalServices.map((service, index) => (
                  <li key={index} className="flex items-start gap-3 group">
                    <CheckCircle2 className="w-5 h-5 text-accent mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform" />
                    <Link 
                      to={`/tratamentos/${service.slug}`}
                      className="text-foreground/80 font-inter leading-relaxed group-hover:text-foreground transition-colors hover:underline"
                    >
                      {service.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>

          {/* Harmonização e Periodontia */}
          <Card className="bg-card border-border hover:border-accent/30 transition-all duration-300 animate-fade-in-up" style={{animationDelay: '0.1s'}}>
            <CardContent className="p-8">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-14 h-14 rounded-full bg-primary flex items-center justify-center flex-shrink-0 shadow-gold">
                  <Stethoscope className="w-7 h-7 text-accent-foreground" />
                </div>
                <div>
                  <h3 className="font-kiona text-2xl font-semibold text-foreground mb-2">
                    Harmonização e Periodontia
                  </h3>
                  <p className="text-sm text-primary font-inter">Beleza e saúde integradas</p>
                </div>
              </div>
              
              <ul className="space-y-3">
                {ambulatoryServices.map((service, index) => (
                  <li key={index} className="flex items-start gap-3 group">
                    <CheckCircle2 className="w-5 h-5 text-accent mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform" />
                    <Link 
                      to={`/tratamentos/${service.slug}`}
                      className="text-foreground/80 font-inter leading-relaxed group-hover:text-foreground transition-colors hover:underline"
                    >
                      {service.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        </div>

        <div className="flex justify-center mt-12 animate-fade-in-up" style={{animationDelay: '0.2s'}}>
          <Link to="/servicos">
            <button className="px-8 py-4 bg-primary hover:bg-primary/90 text-primary-foreground font-inter font-semibold text-base rounded-lg transition-all duration-300 hover-lift shadow-gold flex items-center gap-2">
              Ver todos os tratamentos
              <ArrowUpRight className="w-5 h-5" />
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Services;
